import JsxHelper from '../Helpers/JsxHelper';
import React from 'react';
import RedirectLinkComponent from '../Elements/RedirectLinkComponent';
import EvaluatorPaymentStatusEnum from '../Enums/EvaluatorPaymentStatusEnum';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import TabListTableCellWidthEnum from '../Enums/TabListTableCellWidthEnum';
import DataTableActionMenu from '../Elements/DataTable/DataTableActionMenu';
import AuthService from '../Services/authService';
import AssignmentPaymentDetails from '../Contents/Evaluator/EvaluatorAdmin/EvaluatorPayments/AssignmentPaymentDetails';

export default class EvaluatorPaymentItem {
  constructor(item) {
    this.initialize(item);
    this.Selected = false;
  }

  async initialize(item) {
    this.AsSassieAsgnId = item.asSassieAsgnId;
    // CD-5421: from the related Assignment - the shop was paid to the evaluator outside Bravo.
    this.PaidOutsideOfSystem = item.paidOutsideOfSystem;
    this.IeExportPaymentId = item.ieExportPaymentId;
    this.IeType = item.ieType;
    this.IeStatus = item.ieStatus;
    this.IeStatusCode = item.ieStatusCode;
    this.IePaymentTypeName = item.iePaymentTypeName;
    this.IeFee = item.ieFee;
    this.IeAsid = item.ieAsid;
    this.IeFeeAdjustment = item.ieFeeAdjustment;
    this.IeExpense = item.ieExpense;
    this.IeTotal = item.ieTotal;
    this.IeTotalDisplay = item.ieTotalDisplay;
    this.IeVat = item.ieVat;
    this.IePaid = item.iePaid;
    this.IePaidDisplay = item.iePaidDisplay;
    this.IeDue = item.ieDue;
    this.IePaidOn = item.iePaidOn == null ? '' : item.IePaidOn; // Transaction date?
    this.IeCreatedOn = item.ieCreatedOn;
    this.IeApprovedOn = item.ieApprovedOn == null ? '' : item.ieApprovedOn;
    this.IeRcysymbol = item.ieRcysymbol;
    this.IeRcyName = item.ieRcyName;
    this.CuName = item.cuName;
    this.AsEvname = item.asEvname;
    this.EvaluatorOfficeName = item.evaluatorOfficeName;
    this.IePaymentDate = item.iePaymentDate == null ? '' : item.iePaymentDate;
    this.IeApprovedByName = item.ieApprovedByName;
    this.IeReissuedAs = item.ieReissuedAs;
    this.IeReissuedFrom = item.ieReissuedFrom;
    this.IeVoidReason = item.ieVoidReason;
    this.IeComment = item.ieComment;
    this.IeReimbursement = item.ieReimbursement;
    this.IeTaxableTotal = item.ieTaxableTotal;
    this.IeMisc = item.ieMisc;
    this.IeTravel = item.ieTravel;
    this.IeGaming = item.ieGaming;
    this.IeXpid = item.ieXpid;
    this.IeFeeDisplay = item.ieFeeDisplay;
    this.IeId = item.ieId;
    this.ProjectId = item.projectId == null ? '' : item.projectId;
    this.ProjectName = item.projectName == null ? '' : item.projectName;
    this.ProjectIdAndName = this.ProjectId === '' ? '' : `${this.ProjectId} - ${this.ProjectName}`;
    this.ClientName = item.clientName == null ? '' : item.clientName;
    this.AsEvaluatorCompletedDate = item.asEvaluatorCompletedDate;
    this.CuCountry = item.cuCountry;
    this.IeLdvname = item.ieLdvname;
    this.FieldworkOffice = item.fieldworkOffice;
    this.EvaluatorCurrencyId = item.evaluatorCurrencyId;
    this.IeTypeCode = item.ieTypeCode;
    this.IeCreatedBy = item.ieCreatedBy;
    this.IeCreatedByName = item.ieCreatedByName;
    this.IeAssignedTo = item.ieAssignedTo;
    this.IeAssignedToName = item.ieAssignedToName == null ? '' : item.ieAssignedToName;
    this.IeSubmittedBy = item.ieSubmittedBy;
    this.IeSubmittedOn = item.ieSubmittedOn == null ? '' : item.ieSubmittedOn;
  }

  static NameOfTheIdField() {
    return 'IeId';
  }
  static nameOfTheItemDetailList() {
    return 'Evaluator Payment';
  }

  static MoneyFields = [
    'IeFee',
    'IeFeeAdjustment',
    'IeExpense',
    'IeTotal',
    'IeVat',
    'IePaid',
    'IeDue',
    'IeReimbursement',
    'IeGaming',
    'IeTaxableTotal',
    'IeTravel',
    'IeMisc',
    'IeTotalDisplay',
    'IePaidDisplay',
    'IeFeeDisplay',
  ];

  static Currency() {
    return 'IeRcyName';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return '';
  }

  static DateFields = [
    'IePaidOn',
    'IeCreatedOn',
    'IeApprovedOn',
    'IePaymentDate',
    'AsEvaluatorCompletedDate',
    'IeSubmittedOn',
  ];

  static BoolFields = [];

  static idFunction(item) {
    if (item.AsSassieAsgnId == null) {
      return '';
    }
    return (
      <RedirectLinkComponent
        path='assignments'
        tooltipText={item.AsSassieAsgnId}
        text={item.AsSassieAsgnId}
        keyValuePairs={[
          { key: 'AsBillClient', value: '' },
          { key: 'AsPayEvaluator', value: '' },
          { key: 'AsSassieAsgnId', value: item.AsSassieAsgnId },
        ]}
      />
    );
  }

  static FieldsToShowInDataTable() {
    return [
      {
        label: 'Apollo Job Id',
        orderById: 'AsSassieAsgnId',
        data: 'AsSassieAsgnId',
        type: FieldTypesEnum.DataFieldWithDetails,
        minWidth: 70,
      },
      {
        label: EvaluatorPaymentItem.getSelectedCellHeader,
        orderById: '',
        data: EvaluatorPaymentItem.getSelectedCellContent,
        type: FieldTypesEnum.PureDataField,
        minWidth: 10,
      },
      { label: 'Export', orderById: 'IeXpid', data: 'IeXpid', minWidth: 50 },
      { label: 'Type', orderById: 'IeType', data: 'IeType', minWidth: 50 },
      { label: 'Status', orderById: 'IeStatus', data: 'IeStatus', minWidth: 50 },
      // CD-5421: sits directly after Status on purpose - it is the shop-level setting behind a
      // 'Paid Outside of System' payment status, and it stays visible on payments created before it.
      {
        label: 'Paid Outside of System',
        orderById: 'PaidOutsideOfSystem',
        data: (item) => JsxHelper.YesNo(item.PaidOutsideOfSystem),
        minWidth: 20,
      },
      { label: 'Method', orderById: 'IePaymentTypeName', data: 'IePaymentTypeName', minWidth: 50 },
      { label: 'Fee', orderById: 'IeFeeDisplay', data: 'IeFeeDisplay', minWidth: 50 },
      { label: 'Fee Addit.', orderById: 'IeFeeAdjustment', data: 'IeFeeAdjustment', minWidth: 50 },
      { label: 'Expenses', orderById: 'IeExpense', data: 'IeExpense', minWidth: 50 },
      { label: 'Total', orderById: 'IeTotalDisplay', data: 'IeTotalDisplay', minWidth: 50 },
      { label: 'Tax', orderById: 'IeVat', data: 'IeVat', minWidth: 50 },
      { label: 'Paid', orderById: 'IePaidDisplay', data: 'IePaidDisplay', minWidth: 50 },
      { label: 'Due', orderById: 'IeDue', data: 'IeDue', minWidth: 50 },
      { label: 'Payment Export Date', orderById: 'IePaymentDate', data: 'IePaymentDate', minWidth: 50 },
      { label: 'Created On', orderById: 'IeCreatedOn', data: 'IeCreatedOn', minWidth: 50 },
      { label: 'Approved On', orderById: 'IeApprovedOn', data: 'IeApprovedOn', minWidth: 50 },
      {
        label: ' ',
        orderById: '',
        data: EvaluatorPaymentItem.getActionCellContent,
        type: FieldTypesEnum.ActionButton,
        minWidth: 50,
      },
    ];
  }

  static getSelectedCellContent(item) {
    return (
      <input
        type='checkbox'
        checked={item.Selected}
        onChange={(e) => {
          EvaluatorPaymentItem.clickOnSelect(item, e.target.checked);
        }}
      />
    );
  }

  static clickOnGlobalSelect(item, selected) {
    // Placeholder, don't remove it!
  }

  static selectedStatus() {
    return false;
  }

  static getSelectedCellHeader(item) {
    return (
      <input
        type='checkbox'
        checked={EvaluatorPaymentItem.selectedStatus()}
        onChange={(e) => {
          EvaluatorPaymentItem.clickOnGlobalSelect(item, e.target.checked);
        }}
      />
    );
  }

  static clickOnSelect(item, selected) {
    // Placeholder, don't remove it!
  }

  static actionFunction(ids, actionType) {
    // Placeholder, don't remove it!
  }

  static statusChangeFunction = (item) => {
    // Placeholder, don't remove it!
  };

  static getActionCellContent(item) {
    const alwaysDisabledStatuses = [
      EvaluatorPaymentStatusEnum.Closed,
      // CD-5421: Paid Outside of System is a closed state for every gate below, exactly as Closed is -
      // it replaced the old (Closed + Assignment.PaidOutsideOfSystem) pair.
      EvaluatorPaymentStatusEnum.PaidOutsideOfSystem,
      EvaluatorPaymentStatusEnum.ToBeSentToTipalti,
      EvaluatorPaymentStatusEnum.SentToTipalti,
      EvaluatorPaymentStatusEnum.PendingTipalti,
      EvaluatorPaymentStatusEnum.DeferredOrErrorAtTipalti,
      EvaluatorPaymentStatusEnum.Void,
    ];
    const userId = AuthService.getInstance().GetLoggedInUser().userId.toString();

    const isPaymentRequestType = item.IeType === 'Payment Request';
    const isAdvancePaymentType = item.IeType === 'Advance Payment';
    const isAssignmentPaymentType = item.IeType === 'Assignment Payment';
    const isClosedStatus = [EvaluatorPaymentStatusEnum.Closed, EvaluatorPaymentStatusEnum.PaidOutsideOfSystem].includes(
      item.IeStatusCode
    );
    const isReconciledStatus = item.IeStatusCode === EvaluatorPaymentStatusEnum.Reconciled;
    const isCreatedStatus = item.IeStatusCode === EvaluatorPaymentStatusEnum.Created;
    const isApprovedStatus = item.IeStatusCode === EvaluatorPaymentStatusEnum.Approved;
    const isVoidStatus = item.IeStatusCode === EvaluatorPaymentStatusEnum.Void;

    return (
      <DataTableActionMenu
        options={[
          {
            text: `Assignment Payment (${item.IeId})`,
            link: <AssignmentPaymentDetails id={item.IeId} />,
            iconName: 'fa-solid fa-circle-info',
            hide: item.IeType !== 'Surcharge',
            url: 'paymentdetails',
            roleKey: 'EvaluatorPayment_ActionButton',
          },
          {
            text: 'Approve',
            onClick: () => EvaluatorPaymentItem.actionFunction([item.IeId], 'Approve'),
            iconName: 'fa-solid fa-check',
            // Mirrors the server's allow-list in AssignmentPaymentRepository.ValidateApprovePaymentAsync
            // rather than maintaining a deny-list beside it: the server permits only Created(1) on a
            // non-payment-request. The deny-list this replaced let Paid(3), InfoRequired(9) and both
            // *BySupervisor statuses through to a guaranteed "not eligible to be manually Approved".
            // The server's OTHER clause - PendingApproval(8) on a Payment Request - is deliberately NOT
            // mirrored: payment requests are approved through Status Change, which records the comment and
            // sends the notification, and this menu has always kept them out.
            disabled: !(item.IeStatusCode === EvaluatorPaymentStatusEnum.Created && !isPaymentRequestType),
            hide: isAdvancePaymentType,
            roleKey: 'EvaluatorPayment_ActionButton',
          },
          {
            text: 'Void',
            onClick: () => EvaluatorPaymentItem.actionFunction([item.IeId], 'Void'),
            iconName: 'fa-solid fa-xmark',
            disabled: alwaysDisabledStatuses.includes(item.IeStatusCode) || isPaymentRequestType,
            roleKey: 'EvaluatorPayment_ActionButton',
          },
          {
            text: 'Void and Reissue',
            onClick: () => EvaluatorPaymentItem.actionFunction([item.IeId], 'VoidAndReissue'),
            iconName: 'fa-solid fa-rotate-right',
            disabled:
              alwaysDisabledStatuses.includes(item.IeStatusCode) ||
              [EvaluatorPaymentStatusEnum.Supressed].includes(item.IeStatusCode) ||
              isPaymentRequestType,
            roleKey: 'EvaluatorPayment_ActionButton',
          },
          {
            text: 'Void and Supress',
            onClick: () => EvaluatorPaymentItem.actionFunction([item.IeId], 'VoidAndSupress'),
            iconName: 'fa-solid fa-trash',
            disabled:
              alwaysDisabledStatuses.includes(item.IeStatusCode) ||
              [EvaluatorPaymentStatusEnum.Supressed].includes(item.IeStatusCode) ||
              isPaymentRequestType,
            roleKey: 'EvaluatorPayment_ActionButton',
          },
          {
            text: 'Reissue',
            onClick: () => EvaluatorPaymentItem.actionFunction([item.IeId], 'VoidAndReissue'),
            iconName: 'fa-solid fa-rotate-right',
            // Already reissued once? Then no. The status conjunct that used to sit here made the guard
            // vacuous: `hide` already limits this option to Void/Supressed, so `!includes(status)` was
            // always false when it was visible and the check never fired. pAssignmentPayment_WorkflowVoidAndReissue
            // is the real guard ("… was already reprinted."); this just stops offering the click.
            disabled: item.IeReissuedAs !== null,
            hide: ![EvaluatorPaymentStatusEnum.Void, EvaluatorPaymentStatusEnum.Supressed].includes(item.IeStatusCode),
            roleKey: 'EvaluatorPayment_ActionButton',
          },
          {
            iconName: 'fa-solid fa-edit',
            disabled:
              (((!isPaymentRequestType && !isCreatedStatus) ||
                (isPaymentRequestType && (isClosedStatus || isReconciledStatus))) &&
                !isAdvancePaymentType &&
                (isClosedStatus || isReconciledStatus)) ||
              (isAssignmentPaymentType && !isCreatedStatus && !isApprovedStatus),
            roleKey: 'EvaluatorPayment_ActionButton',
            text: 'Edit',
            onClick: () => EvaluatorPaymentItem.editFunction(item),
          },
          {
            text: 'Status Change',
            onClick: () => EvaluatorPaymentItem.statusChangeFunction(item),
            iconName: 'fa-solid fa-rotate-right',
            disabled:
              isClosedStatus ||
              isReconciledStatus ||
              isVoidStatus ||
              (item.IeCreatedBy !== userId && item.IeAssignedTo !== userId && !AuthService.IsAdmin()),
            hide: !isPaymentRequestType && !isAdvancePaymentType,
            roleKey: 'EvaluatorPayment_ActionButton',
          },
        ]}
      />
    );
  }

  static FieldsToShowInListTable = [
    {
      tabName: 'Info',
      tabLabel: 'Info',
      icon: 'fa-solid fa-info',
      data: [
        { label: 'Type', name: 'IeType' },
        { label: 'Status', name: 'IeStatus' },
        { label: 'Paid Outside of System', name: (item) => JsxHelper.YesNo(item.PaidOutsideOfSystem) },
        { label: 'Assignment', name: EvaluatorPaymentItem.idFunction },
        { label: 'Pay ID', name: 'IeId' },
        { label: 'Location', name: 'CuName' },
        { label: 'Evaluator', name: 'AsEvname' },
        { label: 'Payment Office', name: 'EvaluatorOfficeName' },
        { label: 'Currency', name: 'IeRcyName' },
        { label: 'Payment Method', name: 'IePaymentTypeName' },
        { label: 'Payment Export Date', name: 'IePaymentDate' },
        { label: 'Transaction Date', name: 'IePaidOn' },
        { label: 'Approved On', name: 'IeApprovedOn' },
        { label: 'Created By', name: 'IeCreatedByName' },
        { label: 'Assigned To', name: 'IeAssignedToName' },
        { label: 'Submitted On', name: 'IeSubmittedOn' },
        { label: 'Approved By', name: 'IeApprovedByName' },
        { label: 'Reprinted As', name: 'IeReissuedAs' },
        { label: 'Reprinted From', name: 'IeReissuedFrom' },
        { label: 'Void Reason', name: 'IeVoidReason', width: TabListTableCellWidthEnum.TwoLines },
        { label: 'Comment', name: 'IeComment', width: TabListTableCellWidthEnum.TwoLines },
        { label: 'Fees', name: '-' },
        { label: 'Fee', name: 'IeFeeDisplay' },
        { label: 'Additional Fee', name: 'IeFeeAdjustment' },
        { label: 'Initial Total', name: 'IeTotalDisplay' },
        { label: 'Reimbursement', name: 'IeReimbursement' },
        { label: 'Taxable Total', name: 'IeTaxableTotal' },
        { label: 'Misc', name: 'IeMisc' },
        { label: 'Tax', name: 'IeVat' },
        { label: 'Travel', name: 'IeTravel' },
        { label: 'Paid', name: 'IePaidDisplay' },
        { label: 'Gaming', name: 'IeGaming' },
        { label: 'Current Total Due', name: 'IeDue' },
        { label: 'Export', name: '-' },
        { label: 'Export Payment', name: 'IeExportPaymentId' },
        { label: 'Export', name: 'IeXpid' },
      ],
    },
  ];

  static editFunction = (item) => {
    // Placeholder, don't remove it!
  };
}
